(() => {
window.updateSelectedVariantImage = window.updateSelectedVariantImage || function(variant) {
      if (!variant || !variant.featured_image || !variant.featured_image.src) return;
      var section = document.querySelector('[data-weroll-product-root]');
      var image = section ? section.querySelector('[id^="WerollHeroImage-"]') : null;
      if (!image) return;
      var source = variant.featured_image.src;
      var widths = [360, 480, 600, 640, 720, 800, 900, 960, 1080, 1200];
      var sourceWithWidth = function(width) {
        if (/([?&])width=\d+/.test(source)) {
          return source.replace(/([?&])width=\d+/, '$1width=' + width);
        }
        return source + (source.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
      };
      image.sizes = image.sizes || '(min-width: 990px) 50vw, 100vw';
      image.srcset = widths.map(function(width) {
        return sourceWithWidth(width) + ' ' + width + 'w';
      }).join(', ');
      image.src = sourceWithWidth(1200);
      image.alt = variant.featured_image.alt || image.alt;
    };

    function initialize(section) {
      if (!section || section.dataset.werollProductReady === 'true') return;
      section.dataset.werollProductReady = 'true';
      var hero = section.querySelector('[id^="WerollHeroImage-"]');
      var heroPlayer = section.querySelector('[data-weroll-hero-player]');
      var thumbButtons = Array.from(section.querySelectorAll('[data-weroll-media-thumb]'));
      var prevBtn = section.querySelector('[data-weroll-thumb-prev]');
      var nextBtn = section.querySelector('[data-weroll-thumb-next]');
      var VISIBLE_COUNT = 5;

      var currentOffset = 0;
      var currentIndex = Math.max(0, thumbButtons.findIndex(function(button) {
        return button.classList.contains('is-active');
      }));
      var heroPrevBtn = section.querySelector('[data-weroll-hero-prev]');
      var heroNextBtn = section.querySelector('[data-weroll-hero-next]');
      var heroArea = section.querySelector('[data-weroll-hero-area]');
      var heroDots = Array.from(section.querySelectorAll('[data-weroll-hero-dots] [data-index]'));
      var heroMediaEl = section.querySelector('.weroll-0526__hero-media');
      var thumbsViewport = section.querySelector('.weroll-0526__thumbs-vp');
      var thumbsList = section.querySelector('[data-weroll-thumbs]');
      var heroSlideToken = 0;

      function syncRatingAccessibleName() {
        section.querySelectorAll('.weroll-0526__app-rating a').forEach(function(anchor) {
          var label = anchor.textContent.replace(/\s+/g, ' ').trim();
          if (label) anchor.setAttribute('aria-label', label);
        });
      }

      syncRatingAccessibleName();
      var ratingRoot = section.querySelector('.weroll-0526__app-rating');
      if (ratingRoot && window.MutationObserver) {
        new MutationObserver(syncRatingAccessibleName).observe(ratingRoot, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }

      function getThumbHeight() {
        if (!thumbButtons.length) return 0;
        var rect = thumbButtons[0].getBoundingClientRect();
        return rect.height;
      }

      function isMobileLayout() {
        return window.innerWidth <= 749;
      }

      function syncThumbsHeight() {
        if (isMobileLayout()) return;
        if (!heroMediaEl || !thumbsViewport) return;
        var heroH = heroMediaEl.getBoundingClientRect().height;
        var thumbH = getThumbHeight();
        if (heroH <= 0) return;
        var navH = 32;
        var gap = 6;
        var available = Math.max(heroH - 2 * (navH + gap), navH);
        var visible = thumbH > 0 ? Math.max(1, Math.floor((available + 10) / (thumbH + 10))) : VISIBLE_COUNT;
        thumbsViewport.style.maxHeight = available + 'px';
        updateNavButtons(visible);
      }

      function getVisibleCount() {
        if (!thumbsViewport || !thumbButtons.length) return VISIBLE_COUNT;
        var vpH = thumbsViewport.getBoundingClientRect().height;
        var thumbH = getThumbHeight();
        if (thumbH <= 0) return VISIBLE_COUNT;
        return Math.max(1, Math.floor((vpH + 10) / (thumbH + 10)));
      }

      function updateNavButtons(visibleCount) {
        if (!prevBtn || !nextBtn) return;
        var total = thumbButtons.length;
        var visible = visibleCount || getVisibleCount();
        prevBtn.disabled = currentOffset <= 0;
        nextBtn.disabled = currentOffset >= total - visible;
        if (total <= visible) {
          prevBtn.style.visibility = 'hidden';
          nextBtn.style.visibility = 'hidden';
        } else {
          prevBtn.style.visibility = '';
          nextBtn.style.visibility = '';
        }
      }

      function applyOffset() {
        if (isMobileLayout()) return;
        if (!thumbsList) return;
        var gap = 10;
        var thumbH = getThumbHeight();
        var visible = getVisibleCount();
        var translateY = currentOffset * (thumbH + gap);
        thumbsList.style.transform = 'translateY(-' + translateY + 'px)';
        updateNavButtons(visible);
      }

      function updateHeroArrows() {
        if (!heroPrevBtn || !heroNextBtn) return;
        heroPrevBtn.disabled = currentIndex <= 0;
        heroNextBtn.disabled = currentIndex >= thumbButtons.length - 1;
      }

      function updateDots(idx) {
        heroDots.forEach(function(dot) {
          dot.classList.toggle('is-active', parseInt(dot.dataset.index) === idx);
        });
      }

      function clearHeroPlayer() {
        if (!heroPlayer) return;
        heroPlayer.innerHTML = '';
        heroPlayer.style.display = 'none';
      }

      function removeHeroSlideLayers() {
        if (!heroArea) return;
        heroArea.querySelectorAll('.weroll-0526__hero-slide-image').forEach(function(layer) {
          layer.remove();
        });
      }

      function sourceWithWidth(source, width) {
        if (/([?&])width=\d+/.test(source)) {
          return source.replace(/([?&])width=\d+/, '$1width=' + width);
        }
        return source + (source.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
      }

      function buildHeroSrcset(source) {
        return [360, 480, 600, 640, 720, 800, 900, 960, 1080, 1200].map(function(width) {
          return sourceWithWidth(source, width) + ' ' + width + 'w';
        }).join(', ');
      }

      function createHeroSlideLayer(src, alt) {
        var layer = document.createElement('img');
        layer.sizes = hero.sizes;
        layer.srcset = buildHeroSrcset(src);
        layer.src = src;
        layer.alt = alt || '';
        layer.className = 'weroll-0526__hero-slide-image';
        return layer;
      }

      function slideHeroImage(button, direction, comingFromVideo) {
        var mediaSrc = button.dataset.mediaSrc;
        var mediaAlt = button.dataset.mediaAlt || '';
        if (!hero || !mediaSrc) return;
        heroSlideToken++;
        var token = heroSlideToken;
        var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var startX = direction >= 0 ? '100%' : '-100%';
        var endX = direction >= 0 ? '-100%' : '100%';

        function setImage() {
          if (token !== heroSlideToken) return;
          removeHeroSlideLayers();
          hero.sizes = hero.sizes || '(min-width: 990px) 50vw, 100vw';
          hero.srcset = buildHeroSrcset(mediaSrc);
          hero.src = mediaSrc;
          hero.alt = mediaAlt;
          if (button.dataset.mediaWidth) hero.width = button.dataset.mediaWidth;
          if (button.dataset.mediaHeight) hero.height = button.dataset.mediaHeight;
          hero.style.opacity = '1';
          hero.style.transform = 'translateX(0)';
        }

        if (prefersReducedMotion || typeof hero.animate !== 'function') {
          setImage();
          return;
        }

        function animateLayers() {
          if (token !== heroSlideToken) return;

          removeHeroSlideLayers();
          var incomingLayer = createHeroSlideLayer(mediaSrc, mediaAlt);
          heroArea.appendChild(incomingLayer);

          if (comingFromVideo || hero.style.opacity === '0') {
            incomingLayer.animate(
              [
                { opacity: 0, transform: 'translate3d(' + startX + ', 0, 0)' },
                { opacity: 1, transform: 'translate3d(0, 0, 0)' }
              ],
              { duration: 320, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'forwards' }
            ).finished.then(setImage).catch(setImage);
            return;
          }

          var outgoingLayer = createHeroSlideLayer(hero.currentSrc || hero.src, hero.alt);
          heroArea.appendChild(outgoingLayer);
          hero.style.opacity = '0';

          Promise.all([
            outgoingLayer.animate(
              [
                { opacity: 1, transform: 'translate3d(0, 0, 0)' },
                { opacity: 0.92, transform: 'translate3d(' + endX + ', 0, 0)' }
              ],
              { duration: 360, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'forwards' }
            ).finished,
            incomingLayer.animate(
              [
                { opacity: 0.96, transform: 'translate3d(' + startX + ', 0, 0)' },
                { opacity: 1, transform: 'translate3d(0, 0, 0)' }
              ],
              { duration: 360, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'forwards' }
            ).finished
          ]).then(setImage).catch(setImage);
        }

        function preloadAndAnimate() {
          var preload = new Image();
          preload.onload = animateLayers;
          preload.onerror = animateLayers;
          preload.sizes = hero.sizes;
          preload.srcset = buildHeroSrcset(mediaSrc);
          preload.src = mediaSrc;
        }

        preloadAndAnimate();
      }

      function switchToIndex(idx) {
        if (idx < 0 || idx >= thumbButtons.length) return;
        var button = thumbButtons[idx];
  
      var mediaType = button.dataset.mediaType || 'image';
        if (idx === currentIndex && mediaType === 'image' && (!heroPlayer || heroPlayer.style.display === 'none')) return;
        var slideDirection = idx >= currentIndex ? 1 : -1;

        var comingFromVideo = heroPlayer.style.display !== 'none';
        clearHeroPlayer();

        var mediaTemplate = section.querySelector('template[data-weroll-media-template="' + button.dataset.mediaId + '"]');
        if (mediaType !== 'image' && mediaTemplate && heroPlayer) {
          heroSlideToken++;
          removeHeroSlideLayers();
          if (hero) { hero.style.opacity = '0'; }
          heroPlayer.appendChild(mediaTemplate.content.cloneNode(true));
          heroPlayer.style.display = 'block';
          if (mediaType === 'model' && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
            window.Shopify.loadFeatures([
              {
                name: 'model-viewer-ui',
                version: '1.0',
                onLoad: function(errors) {
                  var modelViewer = heroPlayer.querySelector('model-viewer');
                  if (!errors && modelViewer && window.Shopify.ModelViewerUI) {
                    new window.Shopify.ModelViewerUI(modelViewer);
                  }
                }
              }
            ]);
          }
        } else if (hero && button.dataset.mediaSrc) {
          slideHeroImage(button, slideDirection, comingFromVideo);
        }

        thumbButtons.forEach(function(item) { item.classList.remove('is-active'); });
        button.classList.add('is-active');
        currentIndex = idx;
        updateHeroArrows();
        updateDots(idx);

        if (!isMobileLayout()) {
          var visible = getVisibleCount();
          if (idx < currentOffset) {
            currentOffset = idx;
            applyOffset();
          } else if (idx >= currentOffset + visible) {
            currentOffset = idx - visible + 1;
            applyOffset();
          }
        }
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          if (currentOffset > 0) {
            currentOffset--;
            applyOffset();
          }
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          if (currentOffset < thumbButtons.length - getVisibleCount()) {
            currentOffset++;
            applyOffset();
          }
        });
      }

      if (heroPrevBtn) {
        heroPrevBtn.addEventListener('click', function() {
          switchToIndex(currentIndex - 1);
        });
      }

      if (heroNextBtn) {
        heroNextBtn.addEventListener('click', function() {
          switchToIndex(currentIndex + 1);
        });
      }

      heroDots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          switchToIndex(parseInt(dot.dataset.index));
        });
      });

      thumbButtons.forEach(function(button) {
        button.addEventListener('click', function() {
          var idx = thumbButtons.indexOf(button);
          switchToIndex(idx);
        });
      });

      if (heroArea) {
        var touchStartX = 0;
        var touchStartY = 0;
        heroArea.addEventListener('touchstart', function(e) {
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
        }, { passive: true });
        heroArea.addEventListener('touchend', function(e) {
          var dx = e.changedTouches[0].clientX - touchStartX;
          var dy = e.changedTouches[0].clientY - touchStartY;
          if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
            if (dx < 0) switchToIndex(currentIndex + 1);
            else switchToIndex(currentIndex - 1);
          }
        }, { passive: true });
      }

      updateHeroArrows();
      window.requestAnimationFrame(syncThumbsHeight);

      var secureScrollCta = section.querySelector('[data-weroll-secure-scroll]');
      if (secureScrollCta) {
        function scrollToServiceSelection(target) {
          var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          target.scrollIntoView({
            behavior: prefersReducedMotion ? 'auto' : 'smooth',
            block: 'start'
          });
        }

        function requestServiceSelection() {
          var serviceSection = document.querySelector('.weroll-0526-svc');
          if (!serviceSection) return;
          var serviceEvent = new CustomEvent('weroll:open-service-selection', {
            bubbles: true,
            cancelable: true,
            detail: { sourceSectionId: section.dataset.section }
          });
          var openService = function() {
            serviceSection.dispatchEvent(serviceEvent);
            if (!serviceEvent.defaultPrevented) scrollToServiceSelection(serviceSection);
          };
          if (window.WeRoll0526Loader && serviceSection.dataset.werollModuleReady !== 'true') {
            window.WeRoll0526Loader.activate(serviceSection).then(openService);
          } else {
            openService();
          }
        }

        secureScrollCta.addEventListener('click', requestServiceSelection);
        secureScrollCta.addEventListener('keydown', function(event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          requestServiceSelection();
        });
      }

      var resizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(syncThumbsHeight, 120);
      });

    }

    function initializeAll(scope) {
      if (scope.matches && scope.matches('[data-weroll-product-root]')) initialize(scope);
      scope.querySelectorAll?.('[data-weroll-product-root]').forEach(initialize);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() { initializeAll(document); }, { once: true });
    else initializeAll(document);
    document.addEventListener('shopify:section:load', function(event) { initializeAll(event.target); });
})();
